export default __webpack_public_path__ + "static/media/service--email-marketing.de19cfbe.webp";